import React, { useState } from 'react';
import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { fetchConToken } from '../../api/fetch';
import { useContextInfo } from '../../context/ContextInfo';
export const ModRepair = ({ show, funClose, id }) => {
    const { setResp } = useContextInfo();

    const [load, setLoad] = useState(false);
    const delet = async () => {
        if (load) return;
        setLoad(true);
        const res = await fetchConToken(`networks/repair`, { id }, 'PUT');
        setLoad(false);
        setResp(res);
        funClose();
    };
    return (
        <Modal show={show} onHide={funClose}>
            <Modal.Header onHide={funClose} closeButton>
                <h4 className="modal-title">REPARAR ROUTER</h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body className="text-center">
                                    <svg
                                        aria-hidden="true"
                                        width="60%"
                                        className="mx-auto mb-4 text-warning "
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                    <br />
                                    <b className="mb-5 text-secondary">
                                        ¿Está seguro que desea realizar esta operación?
                                    </b>
                                    <p className="text-11 mb-2">
                                        Al iniciar esta operación el sistema realizará cambios en su mikrotik según la
                                        configuración de su planes de internet en mikrowisp (Crear/editar Colas
                                        simples,etc.)
                                    </p>
                                    <b className="text-12 mb-1">
                                        Esta operación puede tardar un tiempo en terminar,esperar la confirmación de
                                        finalizado.
                                    </b>
                                    <br />
                                    {load ? (
                                        <Button color="primary" disabled>
                                            <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                            Guardando...
                                        </Button>
                                    ) : (
                                        <Button onClick={delet}>Reparar</Button>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};
